import React from "react";
import '../../styles/common/external-link.scss';
import nativeBridge from "../../services/nativeBridge";

function openInBrowserWhenNativeOrNewTab(url: string) {
  if (nativeBridge.isRunningInNativeContainer) {
    nativeBridge.tellNativeToOpenUrlInBrowser(url);
  } else {
    window.open(url, "_blank");
  }
}

export default function ExternalLink({url, title, additionalClassName='', disabled=false, onClick=() => {}}:{url: string, title: string | React.ReactNode, additionalClassName?: string, disabled?: boolean, onClick?: () => void}) {
  return <button
    type="button" // So that it doesn't submit a form (e.g. the "sign-in" form's "forgot your password" link)
    className={`external-link ${additionalClassName}`}
    disabled={disabled}
    onClick={() => {
      onClick();
      openInBrowserWhenNativeOrNewTab(url);
    }}
  >
    {title}
  </button>;
}